var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTourSvg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 202,
    height: 202,
    viewBox: "0 0 202 202",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M103.061 0H98.4556V11.5142H103.061V0Z",
    fill: "#535353"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M103.061 0H98.4556V11.5142H103.061V0Z",
    fill: "#535353"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M103.061 190.001H98.4556V201.516H103.061V190.001Z",
    fill: "#535353"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5147 98.4551H0.000488281V103.061H11.5147V98.4551Z",
    fill: "#535353"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5147 98.4551H0.000488281V103.061H11.5147V98.4551Z",
    fill: "#535353"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M201.516 98.4551H190.001V103.061H201.516V98.4551Z",
    fill: "#535353"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1542 27.8827L27.8975 31.1394L36.0392 39.2811L39.2959 36.0244L31.1542 27.8827Z",
    fill: "#535353"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1542 27.8827L27.8975 31.1394L36.0392 39.2811L39.2959 36.0244L31.1542 27.8827Z",
    fill: "#535353"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M165.488 162.244L162.231 165.501L170.373 173.643L173.629 170.386L165.488 162.244Z",
    fill: "#535353"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0295 162.228L27.8892 170.371L31.1464 173.628L39.2867 165.484L36.0295 162.228Z",
    fill: "#535353"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0295 162.228L27.8892 170.371L31.1464 173.628L39.2867 165.484L36.0295 162.228Z",
    fill: "#535353"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M170.375 27.878L162.235 36.0211L165.492 39.2772L173.632 31.1341L170.375 27.878Z",
    fill: "#535353"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M80.0431 2.12845L75.5586 3.17781L78.182 14.3891L82.6665 13.3398L80.0431 2.12845Z",
    fill: "#535353"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M80.0431 2.12845L75.5586 3.17781L78.182 14.3891L82.6665 13.3398L80.0431 2.12845Z",
    fill: "#535353"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M123.341 187.139L118.856 188.188L121.48 199.399L125.964 198.35L123.341 187.139Z",
    fill: "#535353"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3476 118.848L2.13721 121.476L3.18813 125.96L14.3985 123.332L13.3476 118.848Z",
    fill: "#535353"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3476 118.848L2.13721 121.476L3.18813 125.96L14.3985 123.332L13.3476 118.848Z",
    fill: "#535353"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M198.345 75.5662L187.134 78.1916L188.184 82.6759L199.395 80.0506L198.345 75.5662Z",
    fill: "#535353"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3727 45.6652L13.9443 49.5787L23.728 55.6496L26.1564 51.7361L16.3727 45.6652Z",
    fill: "#535353"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3727 45.6652L13.9443 49.5787L23.728 55.6496L26.1564 51.7361L16.3727 45.6652Z",
    fill: "#535353"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M177.797 145.852L175.369 149.765L185.153 155.836L187.581 151.923L177.797 145.852Z",
    fill: "#535353"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M51.7552 175.359L45.6826 185.142L49.5957 187.571L55.6682 177.788L51.7552 175.359Z",
    fill: "#535353"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M51.7552 175.359L45.6826 185.142L49.5957 187.571L55.6682 177.788L51.7552 175.359Z",
    fill: "#535353"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M151.921 13.9277L145.849 23.7103L149.762 26.1394L155.834 16.3567L151.921 13.9277Z",
    fill: "#535353"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M65.7368 6.2423L61.4561 7.9415L65.704 18.6434L69.9848 16.9442L65.7368 6.2423Z",
    fill: "#535353"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M65.7368 6.2423L61.4561 7.9415L65.704 18.6434L69.9848 16.9442L65.7368 6.2423Z",
    fill: "#535353"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M135.817 182.855L131.537 184.554L135.785 195.256L140.065 193.557L135.817 182.855Z",
    fill: "#535353"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9558 131.525L6.25391 135.773L7.9531 140.054L18.655 135.806L16.9558 131.525Z",
    fill: "#535353"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9558 131.525L6.25391 135.773L7.9531 140.054L18.655 135.806L16.9558 131.525Z",
    fill: "#535353"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M193.569 61.4442L182.867 65.6922L184.566 69.973L195.268 65.725L193.569 61.4442Z",
    fill: "#535353"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M9.17628 58.6984L7.3501 62.9266L17.9205 67.492L19.7466 63.2639L9.17628 58.6984Z",
    fill: "#535353"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M9.17628 58.6984L7.3501 62.9266L17.9205 67.492L19.7466 63.2639L9.17628 58.6984Z",
    fill: "#535353"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M183.623 134.038L181.797 138.266L192.367 142.832L194.193 138.604L183.623 134.038Z",
    fill: "#535353"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2819 181.792L58.7183 192.363L62.9467 194.189L67.5103 183.617L63.2819 181.792Z",
    fill: "#535353"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2819 181.792L58.7183 192.363L62.9467 194.189L67.5103 183.617L63.2819 181.792Z",
    fill: "#535353"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M138.582 7.34403L134.018 17.9152L138.247 19.7406L142.81 9.16947L138.582 7.34403Z",
    fill: "#535353"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1243 16.7268L41.3433 19.3566L47.9179 28.8092L51.6989 26.1793L45.1243 16.7268Z",
    fill: "#535353"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1243 16.7268L41.3433 19.3566L47.9179 28.8092L51.6989 26.1793L45.1243 16.7268Z",
    fill: "#535353"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M153.615 172.698L149.833 175.328L156.408 184.78L160.189 182.15L153.615 172.698Z",
    fill: "#535353"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1855 149.818L16.7329 156.392L19.3628 160.173L28.8153 153.599L26.1855 149.818Z",
    fill: "#535353"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1855 149.818L16.7329 156.392L19.3628 160.173L28.8153 153.599L26.1855 149.818Z",
    fill: "#535353"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M182.17 41.3512L172.717 47.9258L175.347 51.7068L184.8 45.1322L182.17 41.3512Z",
    fill: "#535353"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M1.99272 80.6766L1.17871 85.2097L12.5116 87.2448L13.3256 82.7116L1.99272 80.6766Z",
    fill: "#535353"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M1.99272 80.6766L1.17871 85.2097L12.5116 87.2448L13.3256 82.7116L1.99272 80.6766Z",
    fill: "#535353"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M189.018 114.268L188.204 118.801L199.537 120.836L200.351 116.303L189.018 114.268Z",
    fill: "#535353"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M82.7313 188.187L80.6982 199.52L85.2315 200.333L87.2646 189L82.7313 188.187Z",
    fill: "#535353"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M82.7313 188.187L80.6982 199.52L85.2315 200.333L87.2646 189L82.7313 188.187Z",
    fill: "#535353"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M116.294 1.1717L114.261 12.505L118.794 13.3182L120.827 1.98492L116.294 1.1717Z",
    fill: "#535353"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTourSvg2);
export default __webpack_public_path__ + "static/media/tour_svg_2.9deaf61d23bb358969cac09933a95037.svg";
export { ForwardRef as ReactComponent };